import { TournamentState } from '@ps/poker-games-tile-mappers';
import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { CellProps } from 'react-table';

import { TableCellBase, useStartStateFormatter } from '@swf/poker';
import type { Tournament } from '@swf/poker';

import { isPPTournamentSnG } from '../../../utils';

import { TXTCLI_ON_DEMAND } from './TableCellState.messages.json';

const TableCellState: React.FC<CellProps<Tournament>> = memo((props) => {
  const { row } = props;
  const { formatMessage } = useIntl();
  const { formatStartState } = useStartStateFormatter();

  const displayValue = useMemo(() => {
    if (
      isPPTournamentSnG(row.original?.pokerNgGroup) &&
      row.original.formattedState === TournamentState.REGISTERING
    ) {
      return formatMessage(TXTCLI_ON_DEMAND);
    }

    return formatStartState(
      row.original.formattedState,
      row.original.regEndInt,
      row.original.whenStartInt
    );
  }, [row, formatMessage, formatStartState]);

  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCellState;
